module.exports = __webpack_public_path__ + "img/invoice-icon-01.603d0d11.gif";